import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { faqs } from '../../data/landing';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white py-16 sm:py-24" aria-labelledby="faq-title" data-id="element-104" data-mp="122dcx9d3pxct">
      <div className="mx-auto max-w-3xl px-5" data-id="element-105" data-mp="124g6u4hdkamt">
        <h2 id="faq-title" className="text-center font-display text-[2rem] font-black leading-tight text-navy-900 sm:text-5xl" data-id="element-106" data-mp="1pt901t6m44dq">
          Frequently Asked Questions
        </h2>

        <div className="mt-10 divide-y divide-navy-900/10 border-y border-navy-900/10" data-id="element-107" data-mp="1g1mq0060gbck">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} data-id="element-108" data-mp="28q0nmet6t5nl" data-mpi={i}>
                <h3 data-id="element-109" data-mp="28oz19e6q0wqk">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left text-lg font-extrabold text-navy-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500" data-id="element-110" data-mp="2dhs7y7lr2f5a">
                    {faq.question}
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-brand-500 text-white' : 'bg-brand-50 text-brand-600'}`} data-id="element-111" data-mp="2tnh4664v5l4i">
                      <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-112" data-mp="3cfjobrgprjji" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-113" data-mp="1n153vjcqaitt">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-114" data-mp="1i3d09s2q189s">
                      <p className="pb-5 pr-10 text-base leading-relaxed text-navy-900/75" data-id="element-115" data-mp="2lr9yv4q8gv8f">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <CtaButton className="mt-12" label="I want my playbook now" data-id="element-116" data-mp="2zhdevdyirspf" />
      </div>
    </section>;
}